// extracted by mini-css-extract-plugin
export default {"table":"_ProductTableStyles_table__0jHHH","productAmount":"_ProductTableStyles_productAmount__VJ3G1","productType":"_ProductTableStyles_productType__PR3Gd"};